<app-loader *ngIf="isDisabled"></app-loader>
<div class="container-fluid m-0 p-0">
    <h4 class="text-center mb-4">Salary Billing Rate Contract</h4>
    <div class="card shadow-sm mb-3">
        <div class="card-body">
            <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
                <div class="row g-3">
                    <div class="col-md-3">
                        <label class="form-label">Month / Year <span class="mandatory-field">*</span></label>
                        <ngb-datepicker #MonthYear [(ngModel)]="Filter.MonthYear" class="month-year"
                            (navigate)="Filter.MonthYear= $event.next;onNavigate($event)"
                            [style.pointer-events]="IsReset ? 'none' : 'auto'" required
                            [disabled]="IsReset"></ngb-datepicker>
                        <div class="invalid-feedback">
                            Please select month year!
                        </div>
                    </div>
                    <div class="col-md">
                        <label class="form-label" for="ClientGroupID">Client Group <span
                                class="mandatory-field">*</span></label>
                        <ng-select name="ClientGroupID" [items]="Clients" bindLabel="Column1"
                            bindValue="ClientGroupMasterId" [(ngModel)]="Filter.ClientGroupID" [selectOnTab]="true"
                            (change)="this.DocFillComboLoad('GroupFromClient')" placeholder="Client Group" required
                            [disabled]="IsReset">
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select client group!
                        </div>
                    </div>
                    <div class="col-md">
                        <label class="form-label" for="GroupID">Select Group <span
                                class="mandatory-field">*</span></label>
                        <ng-select name="GroupID" [items]="Groups" bindLabel="Column1" bindValue="GroupMasterID"
                            [(ngModel)]="Filter.GroupID" (change)="this.DocFillComboLoad('SiteDesignationID');clear()"
                            placeholder="Group" required [disabled]="IsReset">
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select group!
                        </div>
                    </div>
                </div>
                <div class="row g-3">
                    <div class="col-md-5">
                        <label class="form-label" for="DesignationID">Designation <span
                                class="mandatory-field">*</span></label>
                        <ng-select name="DesignationID" [items]="Designations" bindLabel="DesignationName"
                            bindValue="DesignationMasterID" [(ngModel)]="Filter.DesignationID"
                            (change)="this.DocFillComboLoad('SiteDutyID');clear()" placeholder="Designation" required
                            [disabled]="IsReset">
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select designation!
                        </div>
                    </div>
                    <div class="col-md-5">
                        <label class="form-label" for="DutyID">Select Duty <span
                                class="mandatory-field">*</span></label>
                        <ng-select name="DutyID" [items]="Dutys" bindLabel="DutyName" bindValue="DutyMasterID"
                            [(ngModel)]="Filter.DutyID" (change)="clear()" placeholder="Duty" required
                            [disabled]="IsReset">
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select duty!
                        </div>
                    </div>
                    <div class="col-md-2 d-flex align-items-end">
                        <button class="btn btn-success w-100" *ngIf="!this.IsReset">OK</button>
                        <button type="button" (click)="clear()" class="btn btn-danger w-100"
                            *ngIf="this.IsReset">Reset</button>
                    </div>
                </div>
            </form>

        </div>
    </div>
    <div class="row mb-3" *ngIf="this.IsReset">
        <div class="col-md-4">
            <label class="form-label">TrackingNo: </label>
            <input class="form-control form-control-sm" name="TrackingNo"
                [(ngModel)]="this.SalaryHeadDetailsOTs.TrackingNo" disabled>
        </div>
        <div class="col-md-4">
            <label class="form-label">Attachmemt: </label>
            <div class="d-flex">
                <Input id="uploadfile" (change)="upload($event)" name="uploadfile"
                    accept=".doc,.docx,.pdf,.jpg,.jpeg,.png" type="file" #uploadfile required matTooltip="Choose File"
                    matTooltipClass="tooltip" style="display: none;" />
                <input class="form-control form-control-sm" name="Attachmemt"
                    [(ngModel)]="this.SalaryHeadDetailsOTs.DocumentPath" disabled>
                <a target="_blank" [href]="this.SalaryHeadDetailsOTs.DocumentPathWebESS" role="button"
                    class="btn btn-secondary mx-2"><i class="bi bi-file-earmark"></i></a>
                <button type="button" class="btn btn-secondary" (click)="uploadfile.click()"><i
                        class="bi bi-cloud-arrow-up"></i></button>
            </div>
        </div>
        <div class="col-md-4 d-flex align-items-end justify-content-end">
            <button class="btn btn-outline-primary me-2"><i class="bi bi-currency-rupee"></i> Previous Rate</button>
            <button class="btn btn-outline-primary"><i class="bi bi-calculator"></i> Calcultion</button>
        </div>
    </div>
    <div class="row" *ngIf="this.IsReset">
        <div class="col-md-12">
            <div class="card shadow-sm mb-3">
                <div class="card-body">
                    <div class="section-title mb-2">
                        <div class="row">
                            <div class="col">
                                Salary Head Details
                            </div>
                            <div class="col-auto d-flex align-items-end gap-1">
                                <label class="form-label" for="SalaryHeadMasterID">Salary Head: </label>
                                <ng-select name="SalaryHeadMasterID" [items]="SalaryHeads" bindLabel="SalaryHeadName"
                                    bindValue="SalaryHeadMasterID" [(ngModel)]="Filter.SalaryHeadMasterID"
                                    placeholder="Salary Head" style="width:22rem;font-weight:400">
                                </ng-select>
                                <button class="btn btn-success" type="button" (click)="addHead()"><i
                                        class="bi bi-plus"></i> Add</button>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm align-middle text-center">
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Salary Head Name</th>
                                    <th>B Computation</th>
                                    <th>B %</th>
                                    <th>B Formula</th>
                                    <th>B Amount</th>
                                    <th>B Monthly / Yearly</th>
                                    <th>B MaxAmount</th>
                                    <th>S Computation</th>
                                    <th>S %</th>
                                    <th>S Formula</th>
                                    <th>S Amount</th>
                                    <th>S Monthly / Yearly</th>
                                    <th>S MaxAmount</th>
                                    <th>Type</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let element of SalaryHeadDetails; let i = index">
                                    <td>{{element.SalaryHeadCode}}</td>
                                    <td>{{element.SalaryHeadName}}</td>
                                    <td class="thbilling data-cell" style="place-items:center">
                                        <select class="form-select form-select-sm" style="width: 10rem;"
                                            title="BComputation" name="BComputation{{i}}" data-live-search="true"
                                            [(ngModel)]="element.BComputation" #BComputation="ngModel"
                                            (change)="ComputationChange(i,1,'B',true)" required
                                            [disabled]="this.common.ToLowerCase(element.HeadType) == 's'">
                                            <option class="text-center" disabled value="">--Select--</option>
                                            @for (Computation of GetComputations(1); track Computation.Value; let i =
                                            $index)
                                            {
                                            <option [value]="Computation.Value">{{Computation.Value}}</option>
                                            }
                                        </select>
                                    </td>
                                    <td class="thbilling data-cell text-end">
                                        <input type="text" class="form-control form-control-sm text-end percent-input"
                                            name="BPercentage{{i}}" #BPercentage="ngModel"
                                            pattern="^\d{1,3}(\.\d{0,2})?$" maxlength="6"
                                            (input)="validatePercentage(element, BPercentage)"
                                            (change)="CalculateOnAmount(element,'B',1,true)"
                                            [ngClass]="{'is-invalid': BPercentage.invalid || element.invalid}"
                                            [(ngModel)]="element.BPercentage" style="width:3rem"
                                            [disabled]="element.BPercentageIsDisabled" required>
                                    </td>
                                    <td class="thbilling data-cell"
                                        (click)="this.common.ToLowerCase(element.BComputation) == 'formula'?this.ComputationChange(i,1,'B'):null">
                                        {{element.BFormula}}
                                    </td>
                                    <td class="thbilling data-cell text-end">
                                        <input type="text" class="form-control form-control-sm text-end percent-input"
                                            name="BAmount{{i}}" pattern="^[0-9.]*$" maxlength="9"
                                            (keypress)="common.NumberOnly($event,common.allowDot(element.BAmount))"
                                            (keyup)="common.NumberOnly($event,common.allowDot(element.BAmount))"
                                            (change)="CalculateOnAmount(element,'B',1,true)"
                                            [(ngModel)]="element.BAmount" style="width:5rem"
                                            [disabled]="element.BAmountIsDisabled" required>
                                    </td>
                                    <td class="thbilling data-cell" style="place-items:center">
                                        <select class="form-select form-select-sm" style="width: 7rem;"
                                            title="BMonthlyYearly" name="BMonthlyYearly{{i}}" data-live-search="true"
                                            [(ngModel)]="element.BMonthlyYearly" #BMonthlyYearly="ngModel"
                                            (change)="MonthlyYearlyChange(i,'B')" required>
                                            <option class="text-center" disabled value="">--Select--</option>
                                            @for (MonthYear of MonthYears; track MonthYear.Value; let i = $index)
                                            {
                                            <option [value]="MonthYear.Value">{{MonthYear.Value}}</option>
                                            }
                                        </select>
                                    </td>
                                    <td class="thbilling data-cell">
                                        <input type="text" class="form-control form-control-sm text-end percent-input"
                                            name="BMaxAmount{{i}}" pattern="^[0-9.]*$" maxlength="9"
                                            (keypress)="common.NumberOnly($event,common.allowDot(element.BMaxAmount))"
                                            (keyup)="common.NumberOnly($event,common.allowDot(element.BMaxAmount))"
                                            (change)="CalculateOnAmount(element,'B',1,true)"
                                            [(ngModel)]="element.BMaxAmount" style="width:5rem"
                                            [disabled]="element.BMaxAmountIsDisabled" required>
                                    </td>

                                    <td class="thsalary data-cell" style="place-items:center">
                                        <select class="form-select form-select-sm" style="width: 10rem;"
                                            title="SComputation" name="SComputation{{i}}" data-live-search="true"
                                            [(ngModel)]="element.SComputation" #SComputation="ngModel"
                                            (change)="ComputationChange(i,1,'S',true)" required
                                            [disabled]="this.common.ToLowerCase(element.HeadType) == 's'">
                                            <option class="text-center" disabled value="">--Select--</option>
                                            @for (Computation of GetComputations(1); track Computation.Value; let i =
                                            $index)
                                            {
                                            <option [value]="Computation.Value">{{Computation.Value}}</option>
                                            }
                                        </select>
                                    </td>
                                    <td class="thsalary data-cell">
                                        <input type="text" class="form-control form-control-sm text-end percent-input"
                                            name="SPercentage{{i}}" pattern="^[0-9.]*$" maxlength="6"
                                            (keypress)="common.NumberOnly($event,common.allowDot(element.SPercentage))"
                                            (keyup)="common.NumberOnly($event,common.allowDot(element.SPercentage))"
                                            (change)="CalculateOnAmount(element,'S',1,true)"
                                            [(ngModel)]="element.SPercentage" style="width:3rem"
                                            [disabled]="element.SPercentageIsDisabled" required>
                                    </td>
                                    <td class="thsalary data-cell"
                                        (click)="this.common.ToLowerCase(element.SComputation) == 'formula'?this.ComputationChange(i,1,'S'):null">
                                        {{element.SFormula}}
                                    </td>
                                    <td class="thsalary data-cell text-end">
                                        <input type="text" class="form-control form-control-sm text-end percent-input"
                                            name="SAmount{{i}}" pattern="^[0-9.]*$" maxlength="9"
                                            (keypress)="common.NumberOnly($event,common.allowDot(element.SAmount))"
                                            (keyup)="common.NumberOnly($event,common.allowDot(element.SAmount))"
                                            (change)="CalculateOnAmount(element,'S',1,true)"
                                            [(ngModel)]="element.SAmount" style="width:5rem"
                                            [disabled]="element.SAmountIsDisabled" required>
                                    </td>
                                    <td class="thsalary data-cell" style="place-items:center">
                                        <select class="form-select form-select-sm" style="width: 7rem;"
                                            title="SMonthlyYearly" name="SMonthlyYearly{{i}}" data-live-search="true"
                                            (change)="MonthlyYearlyChange(i,'S')" [(ngModel)]="element.SMonthlyYearly"
                                            #SMonthlyYearly="ngModel" required>
                                            <option class="text-center" disabled value="">--Select--</option>
                                            @for (MonthYear of MonthYears; track MonthYear.Value; let i = $index)
                                            {
                                            <option [value]="MonthYear.Value">{{MonthYear.Value}}</option>
                                            }
                                        </select>
                                    </td>
                                    <td class="thsalary data-cell">
                                        <input type="text" class="form-control form-control-sm text-end percent-input"
                                            name="SMaxAmount{{i}}" pattern="^[0-9.]*$" maxlength="9"
                                            (keypress)="common.NumberOnly($event,common.allowDot(element.SMaxAmount))"
                                            (keyup)="common.NumberOnly($event,common.allowDot(element.SMaxAmount))"
                                            (change)="CalculateOnAmount(element,'S',1,true)"
                                            [(ngModel)]="element.SMaxAmount" style="width:5rem"
                                            [disabled]="element.SMaxAmountIsDisabled" required>
                                    </td>
                                    <td>{{element.HeadType}}</td>
                                    <td>
                                        <button type="button" class="btn btn-danger" (click)="DeleteHead(i)"><i
                                                class="bi bi-trash"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="card shadow-sm mb-3">
                <div class="card-body">
                    <div class="section-title mb-2">Other Charges</div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm text-center">
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Head Name</th>
                                    <th style="width:11rem">Computation</th>
                                    <th>%</th>
                                    <th>Formula</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let element of AdditionalDetails; let i = index">
                                    <td>{{element.RCChargesCode}}</td>
                                    <td>{{element.RCChargesName}}</td>
                                    <td style="place-items:center">
                                        <select class="form-select form-select-sm" style="width: 10rem;"
                                            title="AComputation" name="AComputation{{i}}" data-live-search="true"
                                            [(ngModel)]="element.Computation" #AComputation="ngModel"
                                            (change)="this.ComputationChange(i,2,'')" required>
                                            <option class="text-center" disabled value="">--Select--</option>
                                            @for (Computation of GetComputations(2); track Computation.Value; let i =
                                            $index)
                                            {
                                            <option [value]="Computation.Value">{{Computation.Value}}</option>
                                            }
                                        </select>
                                    </td>
                                    <td class="text-end">
                                        <input type="text" class="form-control form-control-sm text-end percent-input"
                                            name="OPercentage{{i}}" #OPercentage="ngModel"
                                            pattern="^\d{1,3}(\.\d{0,2})?$" maxlength="6"
                                            (input)="validatePercentage(element, OPercentage)"
                                            (change)="CalculateOnAmount(element,'',2,true)"
                                            [ngClass]="{'is-invalid': OPercentage.invalid || element.invalid}"
                                            [(ngModel)]="element.Column2"
                                            style="width:3rem;min-width: -webkit-fill-available"
                                            [disabled]="element.OPercentageIsDisabled" required>
                                    </td>
                                    <td
                                        (click)="this.common.ToLowerCase(element.Computation) == 'formula'?this.ComputationChange(i,2,''):null">
                                        {{element.Column3}}
                                    </td>
                                    <td class="text-end">
                                        <input type="text" class="form-control form-control-sm text-end percent-input"
                                            name="OAmount{{i}}" pattern="^[0-9.]*$" maxlength="9"
                                            (keypress)="common.NumberOnly($event,common.allowDot(element.A))"
                                            (keyup)="common.NumberOnly($event,common.allowDot(element.A))"
                                            (change)="CalculateOnAmount(element,'',2,true)" [(ngModel)]="element.A"
                                            style="width:5rem;min-width: -webkit-fill-available"
                                            [disabled]="element.OAmountIsDisabled" required>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="card shadow-sm mb-3">
                <div class="card-body">
                    <div class="section-title mb-2">Additional Heads 2</div>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm text-center">
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Head Name</th>
                                    <th style="width:11rem">Computation</th>
                                    <th>%</th>
                                    <th>Formula</th>
                                    <th>Amount</th>
                                    <th>Sale Register Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let element of ServiceDetails; let i = index">
                                    <td>{{element.ServiceChargeCode}}</td>
                                    <td>{{element.ServiceChargeName}}</td>
                                    <td style="place-items:center">
                                        <select class="form-select form-select-sm" style="width: 10rem;"
                                            title="A2Computation" name="A2Computation{{i}}" data-live-search="true"
                                            [(ngModel)]="element.Computation" #A2Computation="ngModel"
                                            (change)="this.ComputationChange(i,3,'')" required>
                                            <option class="text-center" disabled value="">--Select--</option>
                                            @for (Computation of GetComputations(3); track Computation.Value; let i =
                                            $index)
                                            {
                                            <option [value]="Computation.Value">{{Computation.Value}}</option>
                                            }
                                        </select>
                                    </td>
                                    <td class="text-end">
                                        <input type="text" class="form-control form-control-sm text-end percent-input"
                                            name="SPercentage{{i}}" #SPercentage="ngModel"
                                            pattern="^\d{1,3}(\.\d{0,2})?$" maxlength="6"
                                            (input)="validatePercentage(element, SPercentage)"
                                            (change)="CalculateOnAmount(element,'',3,true)"
                                            [ngClass]="{'is-invalid': SPercentage.invalid || element.invalid}"
                                            [(ngModel)]="element.Column2"
                                            style="width:3rem;min-width: -webkit-fill-available"
                                            [disabled]="element.SPercentageIsDisabled" required>
                                    </td>
                                    <td
                                        (click)="this.common.ToLowerCase(element.Computation) == 'formula'?this.ComputationChange(i,3,''):null">
                                        {{element.Column3}}
                                    </td>
                                    <td class="text-end">
                                        <input type="text" class="form-control form-control-sm text-end percent-input"
                                            name="SAmount{{i}}" pattern="^[0-9.]*$" maxlength="9"
                                            (keypress)="common.NumberOnly($event,common.allowDot(element.A))"
                                            (keyup)="common.NumberOnly($event,common.allowDot(element.A))"
                                            (change)="CalculateOnAmount(element,'',3,true)" [(ngModel)]="element.A"
                                            style="width:5rem;min-width: -webkit-fill-available"
                                            [disabled]="element.SAmountIsDisabled" required>
                                    </td>
                                    <td>{{element.SalesRegisterGLCode}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="right-panel mb-3">
                <div class="row">
                    <div class="col-md-4">
                        <h6 class="section-title">OT Details (Salary)</h6>
                        <div class="mb-2">
                            <label class="form-label">OT Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;" title="OTSalay"
                                    name="OTSalay" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.OTType" #OTSalay="ngModel"
                                    (change)="this.ComputationChange(0,4,'OTType',true)" required>
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(4); track Computation.Value; let i = $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="OTRate"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.OTRate" #OTRate="ngModel"
                                    [disabled]="this.SalaryHeadDetailsOTs.OTRateIsDisabled">
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Formula</label>
                            <label class="form-label" style="float: right;"
                                (click)="this.ComputationChange(0,4,'OTType',true)"><i
                                    class="bi bi-plus-square-fill"></i></label>
                            <input type="text" class="form-control form-control-sm" name="OTFormula"
                                [(ngModel)]="this.SalaryHeadDetailsOTs.OTFormula" #OTFormula="ngModel"
                                (click)="this.ComputationChange(0,4,'OTType',true)" readonly
                                [disabled]="this.SalaryHeadDetailsOTs.OTFormulaIsDisabled">
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Fixed Value</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;" title="OTCalculationOn"
                                    name="OTCalculationOn" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.OTCalculationOn" #OTCalculationOn="ngModel"
                                    [disabled]="this.SalaryHeadDetailsOTs.OTCalculationOnIsDisabled" required
                                    (change)="this.ComputationChange(0,5,'OTType',true)">
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(5); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="OTCalculationValue"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.OTCalculationValue"
                                    #OTCalculationValue="ngModel"
                                    [disabled]="this.SalaryHeadDetailsOTs.OTCalculationValueIsDisabled">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <h6 class="section-title">Special OT Details (Salary)</h6>
                        <div class="mb-2">
                            <label class="form-label">OT Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;" title="SpecialOTType"
                                    name="SpecialOTType" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.SpecialOTType" #SpecialOTType="ngModel"
                                    required (change)="this.ComputationChange(0,4,'SpecialOTType',true)">
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(4); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="SpecialOTRate"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.SpecialOTRate" #SpecialOTRate="ngModel"
                                    [disabled]="this.SalaryHeadDetailsOTs.SpecialOTRateIsDisabled">
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Formula</label>
                            <label class="form-label" style="float: right;"
                                (click)="this.ComputationChange(0,4,'SpecialOTType',true)"><i
                                    class="bi bi-plus-square-fill"></i></label>
                            <input type="text" class="form-control form-control-sm" name="SpecialOTFormula"
                                [(ngModel)]="this.SalaryHeadDetailsOTs.SpecialOTFormula" #SpecialOTFormula="ngModel"
                                (click)="this.ComputationChange(0,4,'SpecialOTType',true)" readonly
                                [disabled]="this.SalaryHeadDetailsOTs.SpecialOTFormulaIsDisabled">
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Fixed Value</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;"
                                    title="SpecialOTCalculationOn" name="SpecialOTCalculationOn" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.SpecialOTCalculationOn"
                                    #SpecialOTCalculationOn="ngModel" required
                                    (change)="this.ComputationChange(0,5,'SpecialOTType',true)"
                                    [disabled]="this.SalaryHeadDetailsOTs.SpecialOTCalculationOnIsDisabled">
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(5); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm"
                                    name="SpecialOTCalculationValue"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.SpecialOTCalculationValue"
                                    #SpecialOTCalculationValue="ngModel"
                                    [disabled]="this.SalaryHeadDetailsOTs.SpecialOTCalculationValueIsDisabled">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <h6 class="section-title">Week Off Details (Salary)</h6>
                        <div class="mb-2">
                            <label class="form-label">WO Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;" title="WOType"
                                    name="WOType" data-live-search="true" [(ngModel)]="this.SalaryHeadDetailsOTs.WOType"
                                    #WOType="ngModel" (change)="this.ComputationChange(0,4,'WOType',true)" required>
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(6); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="WOValue"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.WOValue" #WOValue="ngModel">
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Formula</label>
                            <label class="form-label" style="float: right;"
                                (click)="this.ComputationChange(0,4,'WOType',true)"><i
                                    class="bi bi-plus-square-fill"></i></label>
                            <input type="text" class="form-control form-control-sm" name="WOFormula"
                                [(ngModel)]="this.SalaryHeadDetailsOTs.WOFormula" #WOFormula="ngModel" readonly
                                (click)="this.ComputationChange(0,4,'WOType',true)">
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Fixed Value</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;" title="WOOption"
                                    name="WOOption" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.WOOption" #WOOption="ngModel" required>
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(7); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="WeeklyOffAmount"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.WeeklyOffAmount" #WeeklyOffAmount="ngModel"
                                    readonly disabled>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-md-4">
                        <h6 class="section-title">Paid Leave Details (Salary)</h6>
                        <div class="mb-2">
                            <label class="form-label">Leave Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;" title="LeaveType"
                                    name="LeaveType" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.LeaveType" #LeaveType="ngModel"
                                    (change)="this.ComputationChange(0,4,'LeaveType',true)" required>
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(8); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="LeaveValue"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.LeaveValue" #LeaveValue="ngModel"
                                    [disabled]="this.SalaryHeadDetailsOTs.LeaveValueIsDisabled">
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Formula</label>
                            <label class="form-label" style="float: right;"
                                (click)="this.ComputationChange(0,4,'LeaveType',true)"><i
                                    class="bi bi-plus-square-fill"></i></label>
                            <input type="text" class="form-control form-control-sm" name="LeaveFormula"
                                [(ngModel)]="this.SalaryHeadDetailsOTs.LeaveFormula" #LeaveFormula="ngModel"
                                (click)="this.ComputationChange(0,4,'LeaveType',true)" readonly
                                [disabled]="this.SalaryHeadDetailsOTs.LeaveFormulaIsDisabled">
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Fixed Value</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;"
                                    title="LeaveCalculationOn" name="LeaveCalculationOn" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.LeaveCalculationOn"
                                    #LeaveCalculationOn="ngModel" required
                                    (change)="this.ComputationChange(0,5,'LeaveType',true)"
                                    [disabled]="this.SalaryHeadDetailsOTs.LeaveCalculationOnIsDisabled">
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(5); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="LeaveCalculationValue"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.LeaveCalculationValue"
                                    #LeaveCalculationValue="ngModel"
                                    [disabled]="this.SalaryHeadDetailsOTs.LeaveCalculationValueIsDisabled">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <h6 class="section-title">Paid Holiday Details (Salary)</h6>
                        <div class="mb-2">
                            <label class="form-label">Holiday Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;" title="HolidayType"
                                    name="HolidayType" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.HolidayType" #HolidayType="ngModel"
                                    (change)="this.ComputationChange(0,4,'HolidayType',true)" required>
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(8); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="HolidayValue"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.HolidayValue" #HolidayValue="ngModel"
                                    [disabled]="this.SalaryHeadDetailsOTs.HolidayValueIsDisabled">
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Formula</label>
                            <label class="form-label" style="float: right;"
                                (click)="this.ComputationChange(0,4,'HolidayType',true)"><i
                                    class="bi bi-plus-square-fill"></i></label>
                            <input type="text" class="form-control form-control-sm" name="HolidayFormula"
                                [(ngModel)]="this.SalaryHeadDetailsOTs.HolidayFormula" #HolidayFormula="ngModel"
                                (click)="this.ComputationChange(0,4,'HolidayType',true)" readonly
                                [disabled]="this.SalaryHeadDetailsOTs.HolidayFormulaIsDisabled">
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Fixed Value</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;"
                                    title="HolidayCalculationOn" name="HolidayCalculationOn" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.HolidayCalculationOn"
                                    #HolidayCalculationOn="ngModel" required
                                    (change)="this.ComputationChange(0,5,'HolidayType',true)"
                                    [disabled]="this.SalaryHeadDetailsOTs.HolidayCalculationOnIsDisabled">
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(5); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="HolidayCalculationValue"
                                    [(ngModel)]="this.SalaryHeadDetailsOTs.HolidayCalculationValue"
                                    #HolidayCalculationValue="ngModel"
                                    [disabled]="this.SalaryHeadDetailsOTs.HolidayCalculationValueIsDisabled">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12">
            <div class="right-panel mb-3">
                <div class="row">
                    <div class="col-md-4">
                        <h6 class="section-title">OT Details (Billing)</h6>
                        <div class="mb-2">
                            <label class="form-label">OT Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;" title="BOTType"
                                    name="BOTType" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsBillingOTs.BOTType"
                                    (change)="this.ComputationChange(0,4,'BOTType',true)" #BOTType="ngModel" required>
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(9); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="OTBRate"
                                    [(ngModel)]="this.SalaryHeadDetailsBillingOTs.OTBRate" #OTBRate="ngModel"
                                    [disabled]="this.SalaryHeadDetailsBillingOTs.OTBRateIsDisabled">
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">OT Calculation On</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;"
                                    title="BOTCalculationOn" name="BOTCalculationOn" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsBillingOTs.BOTCalculationOn"
                                    #BOTCalculationOn="ngModel" (change)="this.ComputationChange(0,5,'BOTType',true)"
                                    required [disabled]="this.SalaryHeadDetailsBillingOTs.BOTCalculationOnIsDisabled">
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(5); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="BOTCalculationValue"
                                    [(ngModel)]="this.SalaryHeadDetailsBillingOTs.BOTCalculationValue"
                                    #BOTCalculationValue="ngModel"
                                    [disabled]="this.SalaryHeadDetailsBillingOTs.BOTCalculationValueIsDisabled">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <h6 class="section-title">NH Details (Billing)</h6>
                        <div class="mb-2">
                            <label class="form-label">NH Type</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;" title="BHolidayType"
                                    name="BHolidayType" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsBillingOTs.BHolidayType" #BHolidayType="ngModel"
                                    (change)="this.ComputationChange(0,4,'BHolidayType',true)" required>
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(9); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm" name="NationalHolidayRate"
                                    [(ngModel)]="this.SalaryHeadDetailsBillingOTs.NationalHolidayRate"
                                    #NationalHolidayRate="ngModel"
                                    [disabled]="this.SalaryHeadDetailsBillingOTs.NationalHolidayRateIsDisabled">
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">NH Calculation On</label>
                            <div class="d-flex">
                                <select class="form-select form-select-sm" style="width: 10rem;"
                                    title="BHolidayCalculationOn" name="BHolidayCalculationOn" data-live-search="true"
                                    [(ngModel)]="this.SalaryHeadDetailsBillingOTs.BHolidayCalculationOn"
                                    #BHolidayCalculationOn="ngModel"
                                    (change)="this.ComputationChange(0,5,'BHolidayType',true)" required
                                    [disabled]="this.SalaryHeadDetailsBillingOTs.BHolidayCalculationOnIsDisabled">
                                    <option class="text-center" disabled value="">--Select--</option>
                                    @for (Computation of GetComputations(5); track Computation.Value; let i =
                                    $index)
                                    {
                                    <option [value]="Computation.Value">{{Computation.Value}}</option>
                                    }
                                </select>
                                <input type="number" class="form-control form-control-sm"
                                    name="BHolidayCalculationValue"
                                    [(ngModel)]="this.SalaryHeadDetailsBillingOTs.BHolidayCalculationValue"
                                    #BHolidayCalculationValue="ngModel"
                                    [disabled]="this.SalaryHeadDetailsBillingOTs.BHolidayCalculationValueIsDisabled">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="this.IsReset">
        <div class="col-md-4 summary-box">
            <div class="d-flex mb-1"><b>Total:</b>
                <input type="number" style="width:fit-content" class="form-control form-control-sm" name="total"
                    [(ngModel)]="this.Totals.total" disabled>
            </div>
            <div class="d-flex mb-1"><b>Gross Total:</b>
                <input type="number" style="width:fit-content" class="form-control form-control-sm" name="grosstotal"
                    [(ngModel)]="this.Totals.grosstotal" disabled>
            </div>
            <div class="d-flex"><b>Bench Mark:</b>
                <input type="number" style="width:fit-content" class="form-control form-control-sm" name="benchmark"
                    [(ngModel)]="this.Totals.benchmark" disabled>
            </div>
        </div>
        <div class="col-md-4 summary-box">
            <div class="d-flex mb-1"><b>Round Off:</b>
                <input type="number" style="width:fit-content" class="form-control form-control-sm" name="roundoff"
                    [(ngModel)]="this.Totals.roundoff" (change)="CalcTotal()">
            </div>
            <div class="d-flex"><b>Net Total:</b>
                <input type="number" style="width:fit-content" class="form-control form-control-sm" name="nettotal"
                    [(ngModel)]="this.Totals.nettotal" disabled>
            </div>
        </div>
        <div class="col-md-4 summary-box">
            <div class="d-flex mb-1"><b>Billing Total:</b>
                <input type="number" style="width:fit-content" class="form-control form-control-sm" name="billingtotal"
                    [(ngModel)]="this.Totals.billingtotal" disabled>
            </div>
            <div class="d-flex"><b>CTC Total:</b>
                <input type="number" style="width:fit-content" class="form-control form-control-sm" name="ctctotal"
                    [(ngModel)]="this.Totals.ctctotal" disabled>
            </div>
        </div>
    </div>
</div>